module.exports = __webpack_public_path__ + "static/media/card3.2f4d83ac.svg";